import {
  IconChevronRight,
  IconLogout,
  IconSettings,
  IconUser,
} from "@tabler/icons-react";
import { Link } from "react-router-dom";
import {
  Avatar,
  Group,
  Menu,
  Text,
  UnstyledButton,
  Tooltip,
} from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import classes from "./UserButton.module.css";
import { useClerk, useUser } from "@clerk/clerk-react";
import { truncateEmail } from "@/utils/helpers";

export function UserButton() {
  const { signOut } = useClerk();
  const { user } = useUser();
  const isMobile = useMediaQuery("(max-width: 768px)");

  const fullName = [user?.firstName, user?.lastName].filter(Boolean).join(" ");
  const email = user?.primaryEmailAddress?.emailAddress || "";
  const avatarUrl = user?.imageUrl || "";

  return (
    <Menu position={isMobile ? "top-end" : "right"}>
      <Menu.Target>
        <UnstyledButton className={classes.user}>
          <Group wrap="nowrap">
            <Avatar src={avatarUrl} radius="xl" alt={fullName || email} />

            <div style={{ flex: 1, minWidth: 0 }}>
              {fullName ? (
                <Text size="sm" fw={500} truncate>
                  {fullName}
                </Text>
              ) : (
                <Tooltip label={email} withArrow disabled={isMobile}>
                  <Text size="sm" fw={500} truncate>
                    {truncateEmail(email)}
                  </Text>
                </Tooltip>
              )}

              {fullName && (
                <Tooltip label={email} withArrow disabled={isMobile}>
                  <Text c="dimmed" size="xs" truncate>
                    {truncateEmail(email)}
                  </Text>
                </Tooltip>
              )}
            </div>

            <IconChevronRight
              size={16}
              stroke={1.5}
              style={{ flexShrink: 0 }}
            />
          </Group>
        </UnstyledButton>
      </Menu.Target>

      <Menu.Dropdown>
        <Menu.Item
          component={Link}
          leftSection={<IconUser size={16} />}
          to="/profile"
        >
          Profile
        </Menu.Item>
        <Menu.Item
          component={Link}
          leftSection={<IconSettings size={16} />}
          to="/settings"
        >
          Settings
        </Menu.Item>
        <Menu.Item
          leftSection={<IconLogout size={16} />}
          onClick={() => signOut({ redirectUrl: "/login" })}
        >
          Logout
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}
